<template>
  <div
    :class="[
      'ui-notification',
      { 'ui-notification-shake': shaking },
    ]"
    :style="{ borderColor: color }"
  >
    <div class="ui-notification-content">
      <div class="ui-notification-title" v-if="title" v-text="title" />
      <div class="ui-notification-subtitle" v-if="$slots.default">
        <slot />
      </div>
    </div>
    <div class="ui-notification-action" v-if="$slots.action">
      <slot name="action" />
    </div>
    <div
      v-if="closable"
      class="ui-notification-close"
      @click="$emit('remove')"
    >
      <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
    </div>
  </div>
</template>

<script>
import IconClose from '../../../assets/icons/close.svg'

export default {
  name: 'UiNotification',

  icons: {
    IconClose
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    color: {
      type: String,
      default: undefined,
    },

    closable: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    shaking: false,
  }),

  methods: {
    shake() {
      this.shaking = true;
      setTimeout(() => this.shaking = false, 600);
    },
  },
};
</script>

<style lang="scss">
.ui-notification {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  border-left: 4px solid $blue_l;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .04), 0 8px 24px rgba(0, 0, 0, .03), 0 16px 32px rgba(0, 0, 0, .02);
  background: $white;
  padding: 16px 32px 16px 16px;
  margin: 24px 0;
  transition: border-color ease .2s;

  &-content {
    width: 100%;
  }

  &-action {
    margin: 12px 0 0 0;
    display: flex;
    > .ui-button {
      &:not(:first-child) {
        margin-left: 12px;
      }
    }
  }

  &-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
  }

  &-subtitle {
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
    color: $gray;
  }

  &-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    color: $gray_lu;
  }

  &.ui-notification-shake {
    animation: notification-shake .6s ease-out both;
  }

  &.sold-out {
    color: $red;
    border-color: $red;
  }
}

@include breakpoint("tablet") {
  .ui-notification {
    &-action {
      margin: 0 0 0 auto;
    }
  }
}

@include breakpoint("desktop") {
  .ui-notification {
    flex-direction: row;
    &-content {
      width: auto;
    }
    &-title {
      font-size: 16px;
      line-height: 24px;
    }
    &-subtitle {
      font-size: 14px;
    }
  }
}

@keyframes notification-shake {
  10% {
    transform: translate3d(-2px, 0, 0);
  }
  20%,
  90% {
    transform: translate3d(6px, 0, 0);
  }
  50%,
  70% {
    transform: translate3d(-8px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(8px, 0, 0);
  }
}
</style>
